import React from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';
import Typography from '@material-ui/core/Typography';
import { Form } from 'react-final-form';

import Input from 'components/form/Input';

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    borderRadius: 16,
  },
  title: {
    fontWeight: 700,
    fontSize: 22,
    padding: theme.spacing(3, 4, 2),
  },
  close: {
    position: 'absolute',
    right: theme.spacing(2),
    top: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
  content: {
    padding: theme.spacing(2, 4, 1),
  },
  hint: {
    color: theme.palette.text.secondary,
    lineHeight: 1.4,
  },
  actions: {
    padding: theme.spacing(3, 4, 4),
    display: 'flex',
    justifyContent: 'center',
    gap: '16px',
  },
}));

type BulkDeclineDialogProps = {
  open: boolean;
  submitting?: boolean;
  hasSelection: boolean;
  onClose: () => void;
  onSubmit: (values: { note: string }) => Promise<void> | void;
};

const BulkDeclineDialog = ({
  open,
  submitting = false,
  hasSelection,
  onClose,
  onSubmit,
}: BulkDeclineDialogProps) => {
  const classes = useStyles();

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={{ note: '' }}
      render={({ handleSubmit }) => (
        <Dialog
          open={open}
          onClose={onClose}
          fullWidth
          maxWidth="sm"
          classes={{ paper: classes.dialogPaper }}>
          <form onSubmit={handleSubmit}>
            <IconButton className={classes.close} onClick={onClose}>
              <CloseOutlinedIcon />
            </IconButton>
            <DialogTitle className={classes.title}>Decline reason</DialogTitle>
            <DialogContent className={classes.content}>
              <Typography className={classes.hint}>
                Let the user know why their submission was declined. This note is optional.
              </Typography>
              <Input
                name="note"
                label="Decline reason"
                inputProps={{
                  multiline: true,
                  rows: 4,
                  placeholder: 'Explain the reason for the decline',
                }}
              />
            </DialogContent>
            <DialogActions className={classes.actions}>
              <Button
                onClick={onClose}
                disabled={submitting}
                fullWidth
                variant="outlined"
                size="large">
                Cancel
              </Button>
              <Button
                color="primary"
                variant="contained"
                type="submit"
                disabled={submitting || !hasSelection}
                fullWidth
                size="large">
                {submitting ? 'Sending...' : 'Send'}
              </Button>
            </DialogActions>
          </form>
        </Dialog>
      )}
    />
  );
};

export default BulkDeclineDialog;
